import axios from 'axios'

export class Feuerwehr{
    static async get(){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/feuerwehr',{ }
            );

            localStorage.setItem("feuerwehr", JSON.stringify(response.data));
            return response.data;
        } catch (err) {
            return false;
        }
    }
    static async getFeuerwehrByKonvKey(konvKey){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/feuerwehrBykonvKey', { params: { konvKey: konvKey } }
            );
            
            localStorage.setItem("AktiveFeuerwehr", JSON.stringify(response.data));
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async getFeuerwehrByBenutzerEmail(email){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/feuerwehrByBenutzerEmail', { params: { email: email } }
            );
            localStorage.setItem("AktiveFeuerwehr", JSON.stringify(response.data));
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async getFeuerwehrByFeuerwehrID(feuerwehrID){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/feuerwehrByFeuerwehrID', { params: { feuerwehrID: feuerwehrID } }
            );
            localStorage.setItem("AktiveFeuerwehr", JSON.stringify(response.data));
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async getFeuerwehrByFeuerwehrKonvKey(feuerwehrKonvKey){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/feuerwehrByFeuerwehrKonvKey', { params: { feuerwehrKonvKey: feuerwehrKonvKey } }
            );
            localStorage.setItem("AktiveFeuerwehr", JSON.stringify(response.data));
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async update(feuerwehrData){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateFeuerwehr', feuerwehrData);
            console.log(response.data);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
    static async setName(konvKey, name){
        let aktiveFeuerwehr = await this.getFeuerwehrByKonvKey(konvKey);
        if(aktiveFeuerwehr !== false){
            aktiveFeuerwehr.name = name;
            console.log(aktiveFeuerwehr);
            let response = await this.update(aktiveFeuerwehr)
            return response;
        }
    }
    static async setPosition(konvKey, positionX, positionY){
        let aktiveFeuerwehr = await this.getFeuerwehrByKonvKey(konvKey);
        if(aktiveFeuerwehr !== false){
            aktiveFeuerwehr.positionX = positionX;
            aktiveFeuerwehr.positionY = positionY;
            let response = await this.update(aktiveFeuerwehr)
            return response;
        }
    }
    static async setFreischaltPasswort(konvKey, passwort){
        let aktiveFeuerwehr = await this.getFeuerwehrByKonvKey(konvKey);
        if(aktiveFeuerwehr !== false){
            aktiveFeuerwehr.freischaltPasswort = passwort;
            let response = await this.update(aktiveFeuerwehr)
            return response;
        }
    }
    static async setFreischaltPasswortAktiv(konvKey, aktiv){
        let aktiveFeuerwehr = await this.getFeuerwehrByKonvKey(konvKey);
        if(aktiveFeuerwehr !== false){
            aktiveFeuerwehr.freischaltPasswortAktiv = aktiv;
            let response = await this.update(aktiveFeuerwehr)
            return response;
        }
    }
    static async delete(feuerwehrID){
        try{
            await axios.delete(
                'https://feuerwehr-server.org:5000/deleteFeuerwehr',
                { data: { feuerwehrID: feuerwehrID } }
            );
            return true;
        } catch (err){
            console.error(err);
            return false;
        };
    }

    static async add(feuerwehrData){
        try {
            const response = await axios.post('https://feuerwehr-server.org:5000/addFeuerwehr', feuerwehrData);
            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    static async updateAenderungszeiger(feuerwehrID){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateAenderungszeitpunkt', { feuerwehrID });
            console.log(response.data);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
